import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";

import AdminProducts from "../Dashboard/AdminProducts";
import AdminParts from "../Dashboard/AdminParts";
import AdminOrders from "../Dashboard/AdminOrders";
import { API_BASE_URL } from "../../config/api";



const UserDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [permissions, setPermissions] = useState([]);
  const [activePage, setActivePage] = useState("dashboard");
  const [profile, setProfile] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  // ================= FETCH PROFILE =================
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("authToken");

        if (!user?.id) return;

        const res = await fetch(
          `${API_BASE_URL}/api/users/${user.id}/profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!res.ok) {
          throw new Error("Failed to fetch profile");
        }

        const data = await res.json();

        setPermissions(data.permissions || []);
        setProfile(data.user);

        setActivePage("dashboard");

        setForm({
          username: data.user.username,
          password: "",
        });
      } catch (err) {
        console.error("Profile fetch error:", err);
      }
    };

    fetchProfile();
  }, [user?.id]);

  // ================= ACCESS CONTROL =================
  const canAccess = (page) => {
    if (page === "dashboard") return true;
    return permissions.includes(page);
  };

  // ================= UPDATE PROFILE =================
  const updateProfile = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await fetch(
        `${API_BASE_URL}/api/users/${user.id}/profile`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            username: form.username,
            password: form.password,
          }),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to update profile");
      }

      alert("Profile updated");

      setProfile((prev) => ({
        ...prev,
        username: form.username,
      }));

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...user,
          username: form.username,
        })
      );

      setOpenModal(false);
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  // ================= RENDER PAGE =================
  const renderPage = () => {
    if (!canAccess(activePage)) {
      return <div className="text-red-500">No Access</div>;
    }

    switch (activePage) {
      case "dashboard":
        return (
          <div className="space-y-6 ml-2 md:ml-6 lg:ml-80">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-20 max-w-7xl">
              <div className="bg-white rounded-xl shadow p-4 h-40 flex flex-col justify-center items-center text-center">
                <h2 className="text-base font-bold text-gray-800">
                  👋 Welcome {profile?.username}
                </h2>
                <p className="text-gray-500 text-sm mt-1">
                  Role: {profile?.role}
                </p>
              </div>

              <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl shadow p-4 h-40 flex flex-col justify-center items-center text-center">
                <h2 className="text-sm font-semibold">Account Status</h2>
                <p className="text-sm mt-1">Active User</p>
              </div>

              <div className="bg-white rounded-xl shadow p-4 h-40 flex flex-col justify-center items-center text-center">
                <h2 className="text-base font-bold">Permissions</h2>
                <p className="text-gray-500 text-sm mt-1">
                  {permissions.length} modules allowed
                </p>
              </div>
            </div>

            <div className="flex justify-end max-w-7xl">
              <button
                onClick={() => setOpenModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm"
              >
                Edit Profile
              </button>
            </div>
          </div>
        );

      case "products":
        return <AdminProducts />;

      case "parts":
        return <AdminParts />;

      case "orders":
        return <AdminOrders />;

      default:
        return null;
    }
  };

  if (!user) return <h1>Please login</h1>;

  return (
    <div className="flex min-h-screen">
      <Sidebar
        setActivePage={setActivePage}
        permissions={permissions}
        activePage={activePage}
      />

      <main className="flex-1 p-6">{renderPage()}</main>

      {/* ================= MODAL ================= */}
      {openModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white w-[400px] p-6 rounded-2xl shadow-xl">
            <h2 className="text-xl font-bold mb-4">Edit Profile</h2>

            <input
              className="w-full border p-2 rounded mb-3"
              value={form.username}
              onChange={(e) =>
                setForm({ ...form, username: e.target.value })
              }
              placeholder="Username"
            />

            <input
              type="password"
              className="w-full border p-2 rounded mb-4"
              value={form.password}
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
              placeholder="New Password"
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setOpenModal(false)}
                className="px-4 py-2 rounded bg-gray-300"
              >
                Cancel
              </button>

              <button
                onClick={updateProfile}
                className="px-4 py-2 rounded bg-blue-600 text-white"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDashboard;